( function () {
	'use strict';

	function uploadModalCtrl ( fileService, modalInstance, uiUploadFileModel, UPLOAD_EVD_MSGS ) {
		var uploadAPI;
		var self = this;

		self.model = uiUploadFileModel;

		function setDefault () {
			self.model.progressHolder.filename = null;
			self.model.progressHolder.progress = 0;
			self.showInProgressWarning         = false;
		}

		function successUpload ( res ) {
			res.data.title = self.title;
			self.model.successCallback( res.data );
			setDefault();
			modalInstance.close();
		}

		function progressCounter ( evt ) {
			self.model.progressHolder.filename = self.file.filename;
			self.model.progressHolder.progress = Math.min( 100, parseInt( 100.0 * evt.loaded / evt.total ) );
		}

		function confirmModal () {
			self.model.apiParams.file = self.file;
			fileService.uploading.setFlag( true );

			uploadAPI = fileService.upload( self.model.apiParams );

			uploadAPI
				.then( successUpload, setDefault, progressCounter )
				.finally( function () {
					fileService.uploading.setFlag( false );
					uploadAPI = undefined;
				} );
		}

		var passThrough = {
			'$on'   : angular.noop,
			'abort' : angular.noop
		};

		function cancelModal () {
			( uploadAPI || passThrough ).abort();
			modalInstance.dismiss();
		}

		function resetFile () {
			self.file = null;
		}

		( self.model.parentScope || passThrough ).$on( '$destroy', function () {
			self.setDefault();

			( uploadAPI || passThrough ).abort();
		} );

		self.loading = true;
		fileService.initialize()
			.finally( function () {
				self.loading             = false;
				self.acceptedFileFormats = fileService.validation().fileFormats;
			} );

		self.confirmModal = confirmModal;
		self.cancelModal  = cancelModal;
		self.resetFile    = resetFile;
		self.setDefault   = setDefault;
		self.uploading    = fileService.uploading.getFlag();

		self.progressCounter = progressCounter;

		self.showInProgressWarning = self.uploading.flag;

		self.maxSize             = fileService.validation().maxSize;
		self.warningMsgs         = UPLOAD_EVD_MSGS;
	}

	uploadModalCtrl.$inject = [ 'fileService', '$modalInstance', 'uiUploadFileModel', 'UPLOAD_EVD_MSGS' ];

	angular
		.module( 'app.components' )
		.controller( 'uploadModalCtrl', uploadModalCtrl );
} )();
